import { all } from "redux-saga/effects";

//public
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import LayoutSaga from "./layout/saga";

//Company
import Company from "./company/saga";

//User
import User from "./users/saga";

// Profile
import Profile from "./profiles/saga";

//Group
import Group from "./groups/saga";

//Department
import Department from "./departments/saga";

//Skill
import Skill from "./skills/saga";

//Exception
import Exception from "./exceptions/saga";

//Channel
import Channel from "./channels/saga";

// Operator
import Operator from "./operator/saga";

// Summarization
import Summarization from "./summarization/saga";

// Manager
import Manager from "./manager/saga";

//PredefinedMessage
import PredefinedMessage from "./predefinedmessages/saga";

//Script
import Script from "./script/saga";

//AutomaticMessage
import AutomaticMessage from "./automaticmessages/saga";

//Survey
import Survey from "./surveys/saga";

//Availability
import Availability from "./availability/saga";

//Tab
import Tab from "./tabs/saga";

//Feature
import Feature from "./features/saga";

//Edit Profile
import EditProfile from "./editprofile/saga";

// SignalR
import SignalR from "./signalr/saga";

// Flash Message
import FlashMessage from "./flashmessage/saga";

// Transfer Chat
import TransferChat from "./transferChat/saga";

// Notepad
import Notepad from "./notepad/saga";

// Header
import Header from "./header/saga";

// Client Information
import ClientInformation from "./clientInformation/saga";

// Aditional Fields
import AditionalFields from "./aditionalFields/saga";

// Insights
import Insights from "./insights/saga";

// Spy Chat
import SpyChat from "./spyChat/saga";

// Favorite Messages
import FlashMsgs from "./favoriteMessages/saga";

// Favorite Messages
import FavoriteScript from "./favoriteScripts/saga";

// Murals
import Murals from "./murals/saga";

// Dashboard
import Dashboards from "./dashboard/saga";

// Goals
import Goals from "./goals/saga";

// Change display name
import ChangeDisplayName from "./changeDisplayName/saga";

// Variables
import Variables from "./variables/saga";

// SendStatus
import SendStatus from "./sendStatus/saga";

// Reopen Conversation
import ReopenConversation from "./reopenConversation/saga";

// Custom Widgets
import CustomWidgets from "./widgets/saga";

// Attachments Interaction
import AttachmentsInteraction from "./attachmentsInteraction/saga";

// ConsumerTickets
import ConsumerTickets from "./consumerTickets/saga";

// History Interactions
import Interactions from "./interactions/saga";

// Metrics
import Metrics from "./metrics/saga";

// Additional Fields
import AdditionalFields from "./additionalFields/saga";

import TicketsOperatorArea from "./ticketsOperatorArea/saga";

import ManagerTickets from "./managerTickets/saga";

export default function* rootSaga() {
  yield all([
    //public
    AccountSaga(),
    AuthSaga(),
    ForgetSaga(),
    LayoutSaga(),
    Company(),
    User(),
    Profile(),
    Group(),
    Department(),
    Skill(),
    Exception(),
    Channel(),
    PredefinedMessage(),
    Script(),
    AutomaticMessage(),
    Survey(),
    Availability(),
    Tab(),
    Feature(),
    Operator(),
    Manager(),
    EditProfile(),
    SignalR(),
    FlashMessage(),
    TransferChat(),
    Notepad(),
    Header(),
    ClientInformation(),
    AditionalFields(),
    Insights(),
    SpyChat(),
    SendStatus(),
    Murals(),
    Dashboards(),
    FlashMsgs(),
    FavoriteScript(),
    Goals(),
    ChangeDisplayName(),
    Variables(),
    ReopenConversation(),
    CustomWidgets(),
    ConsumerTickets(),
    Interactions(),
    AttachmentsInteraction(),
    Metrics(),
    AdditionalFields(),
    TicketsOperatorArea(),
    ManagerTickets(),
    Summarization(),
  ]);
}
